import { useQuery } from '@hooks/reactQuery';

import { getProjectAdmins } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_ADMINS } from '@constants/queryKeys';

interface IUseQueryProjectAdminsReturned {
	projectAdmins: TNameTitleValueLabel[];
	isLoadingProjectsAdmins: boolean;
}

export const useQueryPlatformOwnerProjectAdmins = (organizationId?: string): IUseQueryProjectAdminsReturned => {
	const {
		data: projectAdmins,
		isLoading: isLoadingProjectsAdmins,
		isFetching: isFetchingProjectsAdmins,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_ADMINS, { organizationId }],
		queryFn: extractQueryParams(getProjectAdmins),
		enabled: [organizationId],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectAdmins: projectAdmins || [],
		isLoadingProjectsAdmins: isLoadingProjectsAdmins || isFetchingProjectsAdmins,
	};
};
